<template>
  <header class="header">
    <Button
      v-if="showBackButton"
      @click="router.push(backTo)"
      :label="isMobile ? '' : backText"
      icon="pi pi-arrow-left"
      severity="contrast"
    />
    <h1 v-if="title">{{ title }}</h1>
  </header>
</template>

<script setup lang="ts">
  import { useRouter } from "vue-router";
  import Button from "primevue/button";
  import { useResponsive } from "../composables/useResponsive";

  const router = useRouter();
  const { isMobile } = useResponsive();

  defineProps({
    title: {
      type: String,
      default: "",
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    backTo: {
      type: String,
      default: "/",
    },
    backText: {
      type: String,
      default: "Terug",
    },
  });
</script>

<style scoped>
  .header {
    position: relative;
    top: 0;
    z-index: 20;
    background: var(--color-background-primary);
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    margin-bottom: 0;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  h1 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--color-text-primary);
  }
</style>
